import { countDirections } from '@api/utils/ontology-utils';
import { useGraphRelations } from '@terminal/react-query-hooks/graph/useGraphRelations';

export type SectorDistribution = {
  name: string;
  value: number;
};

export interface SectorDistributions {
  totalCompaniesCount: number;
  sectorDistributions: SectorDistribution[];
}

export const useThemeDirectionSplit = ({ themeId }: { themeId: string }) => {
  const { data, isFetching, isError } = useGraphRelations({
    node: themeId,
    nodeType: 'theme',
    relationKind: 'theme-company',
    direction: 'outbound',
    maxRank: 1000,
  });
  const directionCounts = countDirections(data?.edges ?? []);

  const total = directionCounts.total;
  const themeDirections =
    total > 0
      ? {
          positive: directionCounts.positive / total,
          negative: directionCounts.negative / total,
          neutral: directionCounts.neutral / total,
          total,
        }
      : undefined;

  return {
    data: themeDirections,
    isFetching,
    isError,
  };
};
